if (Set.prototype.difference == null) {
	Set.prototype.difference = function<T>(other: Set<T>): Set<T> {
		const result = new Set<T>(this);
		for (const item of other) {
			result.delete(item);
		}
		
		return result;
	}
}

if (Set.prototype.symmetricDifference == null) {
	Set.prototype.symmetricDifference = function<T>(other: Set<T>): Set<T> {
		const inThisOnly = this.difference(other);
		const inOtherOnly = other.difference(this);
		
		return new Set<T>([...inThisOnly, ...inOtherOnly]);
	}
}

if (Set.prototype.isDisjointFrom == null) {
	Set.prototype.isDisjointFrom = function<T>(other: Set<T>): boolean {
		const scanning = this.size <= other.size ? this : other;
		const checking = scanning === this ? other : this;
		
		for (const item of scanning) {
			if (checking.has(item)) {
				return false;
			}
		}
		
		return true;
	}
}

declare global {
	interface Set<T> {
		difference(other: Set<T>): Set<T>;
		symmetricDifference(other: Set<T>): Set<T>;
		isDisjointFrom(other: Set<T>): boolean;
	}
}

export {};